import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BootstrapBadge from 'react-bootstrap/Badge';
import {BADGE_COLORS} from '../constants';

const BadgeStyled = styled(BootstrapBadge)`
  &&& {
    background-color: ${({color}) => color};
    padding: 6px 14px;
    border: 0;
    cursor: default;
    color: white;
    font-size: 13px;
  }
`;

const Badge = ({color, children, ...props}) => <BadgeStyled color={color} {...props}>{children}</BadgeStyled>;

Badge.defaultProps = {
  color: BADGE_COLORS.GREY,
  children: null,
};

Badge.propTypes = {
  color: PropTypes.oneOf(Object.values(BADGE_COLORS)),
  children: PropTypes.any,
};

export default Badge;
